import backend, {PAYMENT_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const queryClientSlip = (clientRn, weeklyLastEvaluatedKey, monthlyLastEvaluatedKey) => {
  const queryParam = {
    weeklyLastEvaluatedKey,
    monthlyLastEvaluatedKey,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${PAYMENT_API}/payment/slip/client/${clientRn}?${query}`;
  return backend.get(url);
};

const queryCaregiverSlip = (caregiverRn, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${PAYMENT_API}/payment/slip/caregiver/${caregiverRn}?${query}`;
  return backend.get(url);
};

const markClientSlipCompete = (clientRn, weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/client/${clientRn}/week/${weekOf}/complete`;
  return backend.post(url);
};

const markClientMonthlySlipCompete = (clientRn, monthOf) => {
  const url = `${PAYMENT_API}/payment/slip/client/${clientRn}/month/${monthOf}/complete`;
  return backend.post(url);
};

const markCaregiverSlipCompete = (caregiverRn, weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/caregiver/${caregiverRn}/week/${weekOf}/complete`;
  return backend.post(url);
};

const regenerateClientSlip = (clientRn, date) => {
  const url = `${PAYMENT_API}/payment/slip/client/${clientRn}/regenerate`;
  return backend.post(url, {date});
};

const queryCompletionClient = (weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/client/completion_status/${weekOf}`;
  return backend.get(url);
};

const queryCompletionCaregiver = (weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/caregiver/completion_status/${weekOf}`;
  return backend.get(url);
};

const listCaregiverPaymentSyncCsv = () => {
  const url = `${PAYMENT_API}/payment/slip/caregiver/payment_sync_csv`;
  return backend.get(url);
};

const regenerateCaregiverPaymentSyncCsv = (weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/caregiver/payment_sync_csv/${weekOf}/regenerate`;
  return backend.post(url);
};

export default {
  queryClientSlip,
  queryCaregiverSlip,
  markClientSlipCompete,
  markClientMonthlySlipCompete,
  markCaregiverSlipCompete,
  regenerateClientSlip,
  queryCompletionClient,
  queryCompletionCaregiver,
  listCaregiverPaymentSyncCsv,
  regenerateCaregiverPaymentSyncCsv,
};
